export default "__VITE_ASSET__DZJibFKB__"